<template>
  <div v-if="show" class="c-empty-content">
    <img src="../images/data_empty.png" alt="">
    <p>{{content}}</p>
    <p>{{lastContent}}</p>
  </div>
  <div class="c-empty-administrator" v-else>
    <img src="../images/no-class.png" alt="">
    <p>{{content}}</p>
    <p>{{lastContent}}</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyContent',
  props: {
    content: {
      type: String,
      default: '暂无数据~',
    },
    lastContent: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-empty-content {
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 70px;
  img {
    width: 160px;
  }
  p {
    margin-top: 12px;
    font-size: 14px;
    color: rgba(17, 31, 44, 0.6);
  }
}
.c-empty-administrator {
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 70px;
  img {
    width: 210px;
  }
  p {
    margin-top: 12px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #303133;
  }
}
</style>
